import { render, staticRenderFns } from "./AdminRootApp.vue?vue&type=template&id=23c39f54&"
import script from "./AdminRootApp.vue?vue&type=script&lang=js&"
export * from "./AdminRootApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports